import React from 'react';
import ProgressHeader from './ProgressHeader';
import ContinueButton from './common/ContinueButton';
import { LEARNING_GOALS, MAX_GOALS } from '../constants/onboardingData';

/**
 * Step 5: Sélection des objectifs d'apprentissage (max 3)
 */
export default function Step5Goals({
  formData,
  currentStepNumber,
  currentStepMessage,
  canContinue,
  validationMessage,
  onToggleGoal,
  onContinue,
  onBack,
}) {
  const selectedCount = formData.learningGoals.length;

  return (
    <div className="min-h-[100dvh] bg-[#F0FDFA] flex flex-col">
      <ProgressHeader
        currentStep={currentStepNumber}
        message={currentStepMessage}
        showBack={true}
        onBack={onBack}
      />

      <div className="flex-1 px-4 pb-4 overflow-y-auto">
        {/* Icône et Titre */}
        <div className="text-center py-6">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🎯</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Quels sont vos objectifs pour les 40 prochains jours ?
          </h1>
          <p className="text-gray-600">
            Choisissez jusqu'à <span className='font-bold'>{MAX_GOALS} objectifs</span>
          </p>
          
          {/* Compteur */}
          <div className="inline-block mt-3 bg-white px-4 py-2 rounded-full border border-gray-200">
            <span className="text-gray-600 font-medium">
              {selectedCount}/{MAX_GOALS} sélectionné{selectedCount > 1 ? 's' : ''}
            </span>
          </div>
        </div>

        {/* Liste des objectifs */}
        <div className="space-y-3">
          {LEARNING_GOALS.map((goal) => {
            const isSelected = formData.learningGoals.includes(goal.id);
            const isDisabled = !isSelected && selectedCount >= MAX_GOALS;

            return (
              <div
                key={goal.id}
                onClick={() => !isDisabled && onToggleGoal(goal.id)}
                className={`
                  bg-white rounded-2xl p-4 border-2 transition-all
                  flex items-center gap-4 shadow-lg
                  ${isSelected
                    ? 'border-[#059669] bg-[#F0FDFA]'
                    : isDisabled
                      ? 'border-gray-100 opacity-50 cursor-not-allowed'
                      : 'border-gray-100 hover:border-gray-200 cursor-pointer'
                  }
                `}
              >
                {/* Icône */}
                <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center text-2xl">
                  {goal.icon}
                </div>

                {/* Texte */}
                <p className="flex-1 font-medium text-gray-800">{goal.label}</p>

                {/* Checkbox */}
                <div className={`
                  w-6 h-6 rounded-lg border-2 flex items-center justify-center
                  ${isSelected
                    ? 'border-0 bg-[#059669]'
                    : 'border-gray-300'
                  }
                `}>
                  {isSelected && (
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Bouton Continuer */}
      <div className="sticky bottom-0 bg-[#F0FDFA] p-4 border-t border-gray-100">
        {!canContinue && (
          <p className="text-center text-sm text-gray-500 mb-2">
            {validationMessage}
          </p>
        )}
        <ContinueButton
          onClick={onContinue}
          disabled={!canContinue}
        />
      </div>
    </div>
  );
}
